import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  dl: {
    base: {
      marginTop: 0,
      marginRight: 0,
      marginLeft: 0,
      marginBottom: theme.settings.spacing.large,
    },
    flush: {
      marginBottom: 0,
    },
  },
  dt: {
    base: {
      color: theme.colors.text.dimmed,
      borderBottom: theme.settings.borders.regular,
      margin: 0,
    },
    last: {
      borderBottom: 'none',
    },
    'size-small': {
      paddingTop: theme.settings.spacing.small,
      paddingBottom: theme.settings.spacing.small,
    },
    'size-medium': {
      paddingTop: theme.settings.spacing.medium,
      paddingBottom: theme.settings.spacing.medium,
    },
    'size-large': {
      paddingTop: theme.settings.spacing.large,
      paddingBottom: theme.settings.spacing.large,
    },
  },
  dd: {
    base: {
      borderBottom: theme.settings.borders.regular,
      margin: 0,
    },
    last: {
      borderBottom: 'none',
    },
    'size-small': {
      paddingTop: theme.settings.spacing.small,
      paddingBottom: theme.settings.spacing.small,
    },
    'size-medium': {
      paddingTop: theme.settings.spacing.medium,
      paddingBottom: theme.settings.spacing.medium,
    },
    'size-large': {
      paddingTop: theme.settings.spacing.large,
      paddingBottom: theme.settings.spacing.large,
    },
  },
})
